export default __webpack_public_path__ + "static/media/broadcast.007a9f78.svg";